import { render, staticRenderFns } from "./InfoSimpleIcon.vue?vue&type=template&id=18c652fb&scoped=true"
import script from "./InfoSimpleIcon.vue?vue&type=script&lang=js"
export * from "./InfoSimpleIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c652fb",
  null
  
)

export default component.exports